import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Auth } from "@/types/auth.type";
import { Permission } from "@/types/permission.type";

// Define the initial state using that type
const initialState: { auth: Partial<Auth>} = {
    auth: {},
};

export const authSlice = createSlice({
    name: "auth",
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        addAuth: (state, action: PayloadAction<Partial<Auth>>) => {
            let rules: { [index: string]: string[] } = {}
            action.payload.permissions?.forEach((item: Permission) => {
                if(rules.hasOwnProperty(`${item.model}.${item.role}`)) {
                    rules[`${item.model}.${item.action}`].push(item.role)
                } else {
                    rules[`${item.model}.${item.action}`] = [item.role]
                }
            })
            state.auth = {...action.payload, rules};
        },

        removeAuth: (state) => {
            state.auth = {};
        },
    },
});

export const { addAuth, removeAuth } = authSlice.actions;

// Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value;

export default authSlice.reducer;
